import { render, staticRenderFns } from "./CircleBg.vue?vue&type=template&id=e50d2d66&"
import script from "./CircleBg.vue?vue&type=script&lang=js&"
export * from "./CircleBg.vue?vue&type=script&lang=js&"
import style0 from "./CircleBg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports